import { getProductRouterPath } from '../../products/utils';
import { axiosProvider } from '@/app/core/axios';
import {
  JobsSearchResponse,
  JobsApiSearchResponse,
  JobsDeleteResponse,
  JobsUpdateResponse,
  ProgramSummaryStatsFormat,
  JobsStatsResponse,
  Job,
  ApiResponse,
  SearchRequest,
  DraftsApiSearchResponse,
  DraftsSearchResponse,
} from '@ssar-app/domain';
import { stringify } from 'qs';

const getJobs = (search: SearchRequest): Promise<JobsSearchResponse> => {
  return new Promise((resolve, reject) => {
    const qsConfig = {
      encodeValuesOnly: true,
      allowDots: true,
    };
    const query = stringify(search, qsConfig);
    axiosProvider.apiClient
      .get<JobsApiSearchResponse>(
        `/program/${encodeURIComponent(getProductRouterPath())}/jobs?${query}`,
      )
      .then((response) => {
        if (response) {
          const { data } = response;
          if (data.data) {
            resolve(data.data);
          } else {
            reject('No Programs were found.');
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getJobsStats = (
  searchquery: ProgramSummaryStatsFormat,
): Promise<JobsStatsResponse> => {
  return new Promise((resolve, reject) => {
    const qsConfig = {
      encodeValuesOnly: true,
      allowDots: true,
    };
    const query = stringify(searchquery, qsConfig);
    axiosProvider.apiClient
      .get<JobsStatsResponse>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/jobs/jobsStats?${query}`,
      )
      .then((response) => {
        const { data } = response;
        if (data) {
          resolve(data);
        } else {
          reject('No Programs were found.');
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDrafts = (search: SearchRequest): Promise<DraftsSearchResponse> => {
  return new Promise((resolve, reject) => {
    const qsConfig = {
      encodeValuesOnly: true,
      allowDots: true,
    };
    const query = stringify(search, qsConfig);
    axiosProvider.apiClient
      .get<DraftsApiSearchResponse>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/jobs/drafts?${query}`,
      )
      .then((response) => {
        if (response) {
          const { data } = response;
          if (data.data) {
            resolve(data.data);
          } else {
            reject('No Drafts were found.');
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const deleteJobs = (jobIds: string[]): Promise<JobsDeleteResponse> => {
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .post<JobsDeleteResponse>(
        `/program/${encodeURIComponent(getProductRouterPath())}/jobs/delete`,
        {
          jobIds,
        },
      )
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const deleteDrafts = (jobIds: string[]): Promise<JobsDeleteResponse> => {
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .post<JobsDeleteResponse>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/jobs/deleteDrafts`,
        {
          jobIds,
        },
      )
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateJob = (
  action: string,
  externalSystemRef: string,
): Promise<JobsUpdateResponse> => {
  return axiosProvider.apiClient
    .put<JobsUpdateResponse>(
      `/program/${encodeURIComponent(getProductRouterPath())}/jobs/updateJob`,
      {
        action: action,
        externalSystemRef: externalSystemRef,
      },
    )
    .then((res) => {
      return res.data;
    });
};

const getJobInfoById = (programId: string): Promise<Job> => {
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .get<ApiResponse<Job>>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/jobs/jobInfo?programId=${programId}`,
      )
      .then((response) => {
        if (response) {
          const { data } = response;
          if (data.data) {
            resolve(data.data);
          } else {
            reject('No Program was found.');
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  getJobs,
  deleteJobs,
  getDrafts,
  deleteDrafts,
  updateJob,
  getJobsStats,
  getJobInfoById,
};
